module.exports = __webpack_public_path__ + "img/flyer_06.4be882b8.jpeg";